export class SignPersonalizedTextType {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export const SignPersonalizedTextTypesChoices = {
  STICK_ON_SIGN: new SignPersonalizedTextType('Rechtstreeks kleven op bord', 0),
  SEPARATE_SIGNS: new SignPersonalizedTextType('Tekst op onderbordjes', 1),
  SEPARATE_SIGNS_ABOVE: new SignPersonalizedTextType('Tekst op bovenbordjes', 2)
};

export const SignPersonalizedTextTypesChoiceArray = Object.values(
  SignPersonalizedTextTypesChoices
);
